// @flow

import buildsData from '../buildsMockData.json';
import type { wrappedApiResponseType } from '../../apiTypes';

export const buildsMock = {
  getSingle: (id: number): Promise<wrappedApiResponseType<any>> => {
    const build = buildsData.builds.find(b => b.id === id);

    if (build) {
      return Promise.resolve({
        status: 200,
        statusText: 'OK',
        body: build,
      });
    } else {
      return Promise.reject({
        status: 404,
        message: 'Build not found',
      });
    }
  },

  getMany: (
    limit: number = 100,
    offset: number = 0,
  ): Promise<wrappedApiResponseType<any>> => {
    const paginatedBuilds = buildsData.builds.slice(offset, offset + limit);

    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: paginatedBuilds,
    });
  },
};
